export const hasTouchableProperty = props => props.onPress || props.onPressIn || props.onPressOut || props.onLongPress;
